import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/column/:id",
    name: "Column",
    component: () =>
      import(/* webpackChunkName: "Column" */ "../views/Column.vue"),
    props: true,
  },
  {
    path: "/article/:id",
    name: "Article",
    component: () =>
      import(/* webpackChunkName: "Article" */ "../views/Article.vue"),
    props: true,
  },
  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import(/* webpackChunkName: "Contact" */ "../views/Contact.vue"),
    props: true,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
